<template>
  <div>
    <profile-modal-base
      v-if="!showConfirmationModal"
      :is-open="showModal"
      @close="close"
    >
      <template #header>
        <profile-modal-header
          data-test="additional-settings-modal"
          :header-text="'Additional Settings'"
          :back-target="'profileShowModal'"
        >
        </profile-modal-header>
      </template>
      <modal-row-group>
        <button
          class="button-reset flexbox-row button-row"
          data-test="reset-progress-button"
          @click="openConfirmationModal"
        >
          <span class="text-md font-medium text-error">
            Reset Progress
          </span>
        </button>
        <button
          v-if="isTester"
          class="button-testing flexbox-row button-row"
          data-test="testing-dashboard-button"
          @click="goToTestingDashboard"
        >
          <span class="text-md font-medium">
            Go to Testing Dashboard
          </span>
        </button>
      </modal-row-group>
    </profile-modal-base>
    <confirmation-modal
      v-else
      :confirm-text="'Reset Progress'"
      @close="showConfirmationModal = false"
      @confirm="resetProgress"
    >
      <template #header>
        Warning
      </template>
      <div class="text-sm font-regular">
        Resetting Progress will permanently erase all question tracking data and cannot be undone. Please confirm to proceed.
      </div>
    </confirmation-modal>
  </div>
</template>

<script>
import ConfirmationModal from './ConfirmationModal.vue';
import ModalRowGroup from './ModalRowGroup.vue';
import ProfileModalBase from './ProfileModalBase.vue';
import ProfileModalHeader from './ProfileModalHeader.vue';
import ProfileModalMixin from '@/mixins/profileModal';

const MODAL_NAME = 'additionalSettingsModal';

export default {
  name: 'AdditionalSettingsModal',
  components: {
    ConfirmationModal,
    ModalRowGroup,
    ProfileModalBase,
    ProfileModalHeader,
  },
  mixins: [ProfileModalMixin],
  data() {
    return {
      showConfirmationModal: false,
    };
  },
  computed: {
    showModal() {
      return this.$store.getters['ui/profileModalShown'] === MODAL_NAME;
    },
    isTester() {
      const currentUser = this.$store.getters['session/currentUser'];
      return currentUser && currentUser.tester === true;
    },
  },
  methods: {
    openConfirmationModal() {
      this.showConfirmationModal = true;
    },
    resetProgress() {
      this.showConfirmationModal = false;
      this.$store.dispatch('session/resetProgress').then(_ => {
        this.$analytics.events.resetProgress({ status: 'Success' });
        this.$notify({
          group: 'notifications',
          text: 'Progress reset successfully',
          type: 'success',
        });
        if (this.$route?.name.includes('lesson')) {
          this.$router.push({ name: 'home' });
        }
      }).catch(e => {
        this.$analytics.events.resetProgress({ status: 'Failure' });
        this.$notify({
          group: 'notifications',
          text: 'Unable to reset progress, please contact support',
          type: 'error',
        });
      });
    },
    goToTestingDashboard() {
      this.close();
      this.$router.push({ name: 'testingDashboard' });
    },
  },
};
</script>

<style scoped lang="scss">
.button-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: rem-calc(8);
  padding: 0 rem-calc(20);
  height: rem-calc(48);
}

.button-testing {
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>
